<template>
  <div class="recommend-container">
    <div class="banner-container">
      <img :src="rule.imgUrl" alt="">
    </div>
    <div class="main-container" :style="{ backgroundImage: `url(${rule.bgUrl})`}">
      <save-info-recommend :disabled="disabled" />
      <div class="rule-container">
        <img :src="images.ruleBg" alt="">
        <div class="rule-text">
          <div class="text">
            {{ rule.activityRule }}
          </div>
          <div class="rule-recommend">
            <div class="left" :style="{ backgroundImage: `url(${images.textBg})`}">推荐者</div>
            <div class="right">
              每台奖励 <span>{{ rule.fromDriverAwardPoint }}</span> 积分
            </div>
          </div>
          <div class="rule-recommend">
            <div class="left" :style="{ backgroundImage: `url(${images.textBg})`}">被推荐者</div>
            <div class="right">
              每台奖励 <span>{{ rule.toDriverAwardPoint }}</span> 积分
            </div>
          </div>
        </div>
      </div>
    </div>
    <download-app :bg="rule.bgUrl" :disabled="disabled" />
  </div>
</template>

<script>
import ruleBg from '@/assets/images/recommend/rule-bg.png'
import textBg from '@/assets/images/recommend/text-bg.png'
import SaveInfoRecommend from '@/components/SaveInfoRecommend.vue'
import DownloadApp from '@/components/DownloadApp.vue'
import { getWxConfig } from '@/api'
import { initWx } from '@/utils/jssdk'
import { getRecommendConfig, getShareConfig } from '@/api/recommend'

export default {
  name: 'index',
  components: { SaveInfoRecommend, DownloadApp },
  data() {
    return {
      images: {
        ruleBg,
        textBg
      },
      rule: {
        activityRule: null,
        bgUrl: null,
        fromDriverAwardPoint: null,
        imgUrl: null,
        toDriverAwardPoint: null
      },
      disabled: false
    }
  },
	created() {
    const {
      platform, app, phone, name
    } = this.$route.query
    this.disabled = !(platform && app && phone && name)
    getShareConfig()
      .then((config) => {
        getWxConfig({ url: window.location.href })
          .then((res) => initWx(res.data))
          .then(() => {
            // eslint-disable-next-line no-undef
            wx.ready(() => {
              const content = {
                title: config.data.wxLinkTitle,
                desc: config.data.wxLinkContent,
                link: window.location.href,
                imgUrl: config.data.wxLinkImgUrl,
                success: () => {}
              }
              // eslint-disable-next-line no-undef
              wx.updateTimelineShareData(content)
              // eslint-disable-next-line no-undef
              wx.updateAppMessageShareData(content)
            })
          })
      })
    getRecommendConfig()
      .then((res) => {
        this.rule = res.data
      })
	}
}
</script>

<style scoped lang="scss">
.recommend-container{
  img{
    width: 100%;
    display: block;
  }
  .rule-container{
    position: relative;
    .rule-text{
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      padding-top: rem(120);
      padding-left: rem(50);
      padding-right: rem(50);
      .text{
        font-size: rem(26);
        color: #690b00;
        line-height: rem(48);
        text-align: justify;
        text-indent: rem(52);
        margin-bottom: rem(70);
      }
      .rule-recommend{
        display: flex;
        justify-content: space-between;
        margin-bottom: rem(30);
        .left{
          width: rem(306);
          height: rem(38);
          font-size: rem(28);
          color: #690b00;
          padding-left: rem(67);
          line-height: rem(38);
          background-position: initial;
          background-repeat: no-repeat;
          background-size: contain;
          flex-shrink: 0;
          flex-grow: 0;
          box-sizing: border-box;
        }
        .right{
          font-size: rem(28);
          color: #666666;
          span{
            color: #e43425;
            font-weight: bolder;
          }
        }
      }
    }
  }
}
</style>
